import { render, staticRenderFns } from "./PublicPersonalCenter.vue?vue&type=template&id=a00a4bd2&scoped=true&"
import script from "./PublicPersonalCenter.vue?vue&type=script&lang=js&"
export * from "./PublicPersonalCenter.vue?vue&type=script&lang=js&"
import style0 from "./PublicPersonalCenter.vue?vue&type=style&index=0&id=a00a4bd2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a00a4bd2",
  null
  
)

export default component.exports